import {PermissionType} from '@hconnect/apiclient'
import {usePlantsByPermission} from '@hproduce/permissions'

import {getAllowedLocations} from '../utils'

import {useHierarchy} from './api'

export const useHierarchyNavAccess = (permission: PermissionType) => {
  const {data: hierarchy, isInitialLoading, isError, refetch} = useHierarchy()
  const {plantIds: allowedPlants, isLoading: isPermissionsLoading} =
    usePlantsByPermission(permission)

  const {areas, plantsByArea} = getAllowedLocations(hierarchy, allowedPlants)
  const getPlantsByAreaId = (areaId: string) => plantsByArea[areaId] || []
  const getAreaById = (areaId: string) => areas[areaId] || null

  return {
    isInitialLoading: isInitialLoading || isPermissionsLoading,
    isError,
    refetch,
    allowedPlants,
    allowedAreas: Object.keys(areas),
    getPlantsByAreaId,
    getAreaById
  }
}
